(function(){
  function qs(s, r){ return (r||document).querySelector(s); }
  function qsa(s, r){ return Array.from((r||document).querySelectorAll(s)); }

  function init(){
    var bubble = qs('.fvb-bubble');
    var modal  = qs('.fvb-modal');

    if(!bubble){
      console.warn('[FV Bubble] Bubble não encontrada na página.');
      return;
    }
    if(!modal){
      console.warn('[FV Bubble] Modal não encontrado na página.');
      return;
    }

    // DEBUG: ver se o vídeo foi capturado
    console.log('[FV Bubble] Vídeo capturado?', {
      mediaId: bubble.getAttribute('data-media-id'),
      mediaType: bubble.getAttribute('data-media-type'),
      host: bubble.getAttribute('data-host')
    });

    var backdrop = qs('.fvb-backdrop', modal);
    var closeBtn = qs('.fvb-close', modal);

    function openModal(){
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      var v = qs('video.fvb-html5', modal);
      if(v){ try{ v.play().catch(()=>{}); }catch(e){} }
    }

    function stopPlayback(){
      var v = qs('video.fvb-html5', modal);
      if(v){ try{ v.pause(); }catch(e){} }
      qsa('iframe.fvb-iframe', modal).forEach(function(ifr){
        var src = ifr.getAttribute('src');
        ifr.setAttribute('src','');
        setTimeout(function(){ ifr.setAttribute('src', src); }, 0);
      });
    }

    function closeModal(){
      stopPlayback();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }

    bubble.addEventListener('click', openModal);
    bubble.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openModal(); }
    });
    backdrop && backdrop.addEventListener('click', closeModal);
    closeBtn && closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
